import React from "react";
import { valueToString } from "helpers/Helpers";
import classNames from "classnames";

import BaseReportTable from "./BaseReportTable";

import "components/reportTable/reportTable.scss";
import { formatReportCurrency } from "helpers/reportFormat";

interface IProps {
  data: Array<Record<string, any>>;
  columns: Array<Record<string, any>>;
  description: string;
  compileDate: string;
}

export default function TransactionsTable(props: IProps) {

  function formatDisplay(type: string, value: string) {
    let newValue = value !== null && value !== undefined ? value : "";

    if (!isNaN(Number(newValue)) && newValue !== "") {
      switch (type) {
        case "currency":
          newValue = formatReportCurrency(value);
          break;
        case "decimal":
          newValue = Number(value).toFixed(2);
          break;
        case "percentage":
          newValue = `${Number(value) * 100}%`;
          break;
        default:
          break;
      }
    } else if (type === "string" && newValue !== "") {
      newValue = valueToString(value).replace(/(^\w|\s\w)/g, c => c.toUpperCase());
    }

    return newValue;
  }

  // Format cell data based on column
  function cellData(columnId: string, cellValue: string, displayType: string, cell: any) {
    switch (columnId) {
      case "order_name":
        return cell.row.original.source_order_id
          ? formatDisplay(displayType, `${String(cell.value)}`)
          : cell.row.original.source_invoice_id ? formatDisplay(displayType, `Invoice ${String(cell.value)}`)
            : cell.row.source_account_id ? formatDisplay(cell?.column?.display_type as string, `Account ${String(cell.value)}`) : null;
      default:
        return formatDisplay(displayType, cellValue);
    }
  }

  // Add on click events based on column
  function cellOnClick(cell: any) {
    if (!cell) {
      return null;
    }
    switch (cell.column.id) {
      case "order_name":
        return cell.row.original.source_order_id
          ? window.open(`/admin/order/${String(cell.row.original.source_order_id)}`) :
          cell.row.original.source_invoice_id ? window.open(`/admin/invoices/${String(cell.row.original.source_invoice_id)}/edit`)
            : cell.row.source_account_id ? window.open(`/admin/settings/accounts/overview/${String(cell.row.original.source_account_id)}`) : null;
      default:
        return null;
    }
  }

  function cellClassNames(cell: any, isRowLocked: boolean) {
    return classNames({
      "report-table-row-locked": isRowLocked,
      "report-table-cell-clickable": cell.column.id === "order_name",
    });
  }

  // Add footer data based on column
  function footerData(columnId: string, footerRow?: Record<string, any>) {
    if (!footerRow) {
      return null;
    }
  
    switch (columnId) {
      case "processed_at_local":
        return footerRow?.processed_at_local as string;
  
      case "amount":
      case "fee":
      case "net":
        return formatDisplay(
          "currency",
          String(footerRow[columnId] ?? 0),
        );
  
      default:
        return null;
    }
  }

  // function getTotal(columnId: string, type: string): number | string {
  //   let total = 0;
  //   props.data.forEach(row => {
  //     if (row[columnId]) {
  //       if (row.source_type === 'refund') {
  //         total -= Number(row[columnId]);
  //       } else {
  //         total += Number(row[columnId]);
  //       }
  //     }
  //   });
  //   if (type === "currency") {
  //     return formatReportCurrency(total);
  //   } else {
  //     return total;
  //   }
  // }

  return (
    <BaseReportTable
      data={props.data}
      columns={props.columns}
      description={props.description}
      compileDate={props.compileDate}
      cellOnClick={cellOnClick}
      cellData={cellData}
      cellClassNames={cellClassNames}
      footerData={footerData}
      expanding={false}
    />
  );
}
